// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  background-color: #1a1a1a;
  color: #ffffff;
  overflow: hidden;
}

/* 应用主容器 */
.app {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-header {
  background: #2d2d2d;
  padding: 10px 20px;
  border-bottom: 1px solid #404040;
  -webkit-app-region: drag;
}

.app-header h1 {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  -webkit-app-region: no-drag;
}

.app-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 按钮样式 */
.btn-primary {
  background: #007AFF;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.btn-primary:hover {
  background: #0056CC;
}

.btn-primary:disabled {
  background: #666;
  cursor: not-allowed;
}

.btn-control {
  background: #333;
  color: white;
  border: 1px solid #555;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  min-width: 40px;
}

.btn-control:hover {
  background: #444;
}

.btn-control:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 视频播放器样式 */
.video-player {
  background: #000;
  border-bottom: 1px solid #333;
}

.video-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  background: #2d2d2d;
  border-bottom: 1px solid #404040;
}

.speed-select {
  background: #333;
  color: white;
  border: 1px solid #555;
  padding: 6px 8px;
  border-radius: 4px;
  cursor: pointer;
}

.recording-buttons {
  display: flex;
  gap: 8px;
  margin-left: auto;
}

.btn-offense {
  background: #4CAF50;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-offense:hover {
  background: #45a049;
}

.btn-offense.recording {
  background: #FF5722;
  animation: pulse 1s infinite;
}

.btn-defense {
  background: #F44336;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-defense:hover {
  background: #d32f2f;
}

.btn-defense.recording {
  background: #FF5722;
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.7; }
  100% { opacity: 1; }
}

.video-container {
  position: relative;
  height: 300px;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-element {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.video-placeholder {
  text-align: center;
  color: #888;
}

.video-placeholder p {
  margin-bottom: 16px;
  font-size: 16px;
}

.progress-container {
  padding: 12px 20px;
  background: #2d2d2d;
}

.progress-bar {
  position: relative;
  height: 6px;
  background: #444;
  border-radius: 3px;
  cursor: pointer;
  margin-bottom: 8px;
}

.progress-fill {
  height: 100%;
  background: #007AFF;
  border-radius: 3px;
  transition: width 0.1s;
}

.recording-marker {
  position: absolute;
  top: -2px;
  width: 3px;
  height: 10px;
  border-radius: 1px;
}

.offense-marker {
  background: #4CAF50;
}

.defense-marker {
  background: #F44336;
}

.time-display {
  text-align: center;
  font-size: 14px;
  color: #ccc;
  font-family: 'Monaco', 'Menlo', monospace;
}

/* 时间轴样式 */
.timeline-container {
  background: #2d2d2d;
  border-bottom: 1px solid #404040;
  padding: 16px 20px;
}

.timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.timeline-header h3 {
  font-size: 16px;
  color: #fff;
}

.timeline-info {
  display: flex;
  gap: 20px;
  font-size: 12px;
  color: #888;
  font-family: 'Monaco', 'Menlo', monospace;
}

.timeline-track {
  position: relative;
  height: 40px;
  background: #1a1a1a;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 8px;
}

.time-markers {
  position: absolute;
  top: -20px;
  left: 0;
  right: 0;
  height: 20px;
}

.time-marker {
  position: absolute;
  font-size: 10px;
  color: #666;
}

.marker-line {
  width: 1px;
  height: 8px;
  background: #666;
  margin-bottom: 2px;
}

.marker-text {
  font-family: 'Monaco', 'Menlo', monospace;
  white-space: nowrap;
  transform: translateX(-50%);
}

.timeline-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #333;
  border-radius: 4px;
}

.timeline-progress {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 122, 255, 0.3);
  border-radius: 4px;
}

.timeline-playhead {
  position: absolute;
  top: -5px;
  bottom: -5px;
  width: 2px;
  transform: translateX(-1px);
}

.playhead-line {
  width: 2px;
  height: 100%;
  background: #007AFF;
}

.playhead-handle {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 12px;
  height: 12px;
  background: #007AFF;
  border: 2px solid #fff;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  cursor: grab;
}

.playhead-handle:active {
  cursor: grabbing;
}

.timeline-time-display {
  text-align: center;
  font-size: 14px;
  color: #ccc;
  font-family: 'Monaco', 'Menlo', monospace;
}

.timeline-placeholder {
  text-align: center;
  padding: 40px;
  color: #666;
}

/* 轨道列表样式 */
.track-list {
  flex: 1 1;
  background: #1a1a1a;
  overflow-y: auto;
  padding: 20px;
}

.track-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.track-list-header h3 {
  font-size: 18px;
  color: #fff;
}

.btn-add-track {
  background: #007AFF;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.btn-add-track:hover {
  background: #0056CC;
}

.new-track-input {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  padding: 12px;
  background: #2d2d2d;
  border-radius: 6px;
}

.new-track-input input {
  flex: 1 1;
  background: #333;
  border: 1px solid #555;
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
}

.new-track-input input:focus {
  outline: none;
  border-color: #007AFF;
}

.btn-confirm {
  background: #4CAF50;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.btn-cancel {
  background: #666;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.tracks-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.track-item {
  background: #2d2d2d;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #404040;
  transition: all 0.2s ease;
  cursor: default;
  position: relative;
}

.track-item:hover {
  border-color: #555;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

/* 拖拽状态样式 - 由framer-motion的whileDrag控制 */
.track-item[data-rbd-dragging-over] {
  background: #3a3a3a;
  border-color: #007AFF;
  box-shadow: 0 4px 16px rgba(0, 122, 255, 0.2);
}

/* 拖拽占位符样式 */
.track-item[data-rbd-drag-handle-dragging-color] {
  background: #3a3a3a !important;
  border-color: #007AFF !important;
  transform: rotate(1deg) scale(1.02);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4);
  z-index: 1000;
}

.track-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
}

.track-header:active {
  cursor: grabbing;
}

.track-drag-handle {
  display: flex;
  align-items: center;
  padding: 4px;
  margin-right: 8px;
  cursor: grab;
}

.track-drag-handle:active {
  cursor: grabbing;
}

.drag-dots {
  display: grid;
  grid-template-columns: repeat(2, 4px);
  grid-template-rows: repeat(3, 4px);
  gap: 2px;
  opacity: 0.6;
  transition: opacity 0.2s;
}

.track-header:hover .drag-dots {
  opacity: 1;
}

.drag-dots span {
  width: 4px;
  height: 4px;
  background: #888;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.track-header:hover .drag-dots span {
  background: #ccc;
}

.track-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.track-color-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.track-name {
  font-size: 16px;
  color: #fff;
  cursor: pointer;
}

.track-name:hover {
  color: #007AFF;
}

.track-stats {
  display: flex;
  gap: 16px;
  font-size: 12px;
  color: #888;
}

.track-controls {
  display: flex;
  gap: 8px;
}

.btn-play-track {
  background: #4CAF50;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-play-track:disabled {
  background: #666;
  cursor: not-allowed;
}

.btn-export-track {
  background: #FF9800;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

.btn-export-track:disabled {
  background: #666;
  cursor: not-allowed;
}

.btn-delete-track {
  background: #F44336;
  color: white;
  border: none;
  padding: 6px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
}

.clips-container {
  min-height: 60px;
}

.empty-track-message {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  border: 2px dashed #555;
  border-radius: 4px;
  color: #888;
  font-size: 14px;
  text-align: center;
  padding: 10px;
}

.empty-track {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  border: 2px dashed #555;
  border-radius: 4px;
  color: #888;
  font-size: 14px;
}

.clips-grid {
  display: flex;
  gap: 8px;
  flex-wrap: nowrap;
  align-items: center;
  min-height: 50px;
  padding: 4px;
  overflow-x: auto;
  scroll-behavior: smooth;
  justify-content: flex-start;
}

.clips-grid > * {
  flex-shrink: 0;
  margin: 0;
}

.clips-grid::-webkit-scrollbar {
  height: 4px;
}

.clips-grid::-webkit-scrollbar-track {
  background: transparent;
}

.clips-grid::-webkit-scrollbar-thumb {
  background: #555;
  border-radius: 2px;
}

.clips-grid::-webkit-scrollbar-thumb:hover {
  background: #666;
}

.clips-list {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.track-summary {
  margin-top: 20px;
  padding: 16px;
  background: #2d2d2d;
  border-radius: 6px;
  display: flex;
  gap: 20px;
}

.summary-item {
  font-size: 14px;
  color: #ccc;
}

/* 片段样式 */
.clip-item {
  position: relative;
  background: #4CAF50;
  border-radius: 6px;
  padding: 6px 10px;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  border: 2px solid transparent;
  transition: all 0.2s ease;
  min-width: 80px;
  max-width: 150px;
  width: auto;
  display: inline-block;
  flex-shrink: 0;
  vertical-align: top;
  box-sizing: border-box;
}

.clip-item:hover {
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.clip-item:active {
  cursor: grabbing;
}

/* 拖拽时的插入指示器 */
.clips-grid::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #007AFF;
  opacity: 0;
  transition: opacity 0.2s ease;
  pointer-events: none;
}

.clips-grid[data-dragging="true"]::before {
  opacity: 1;
}

/* 拖拽占位符样式 */
.clip-item[data-rbd-dragging-over] {
  background: rgba(255, 255, 255, 0.1) !important;
  border: 2px dashed #007AFF !important;
}

.clip-item[data-rbd-drag-handle-dragging-color] {
  opacity: 0.8;
  transform: rotate(2deg) scale(1.05);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4);
}

.clip-item.offense {
  background: #4CAF50;
}

.clip-item.defense {
  background: #F44336;
}

.trim-handle {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 8px;
  background: rgba(255, 255, 255, 0.3);
  cursor: ew-resize;
  opacity: 0;
  transition: opacity 0.2s;
}

.clip-item:hover .trim-handle {
  opacity: 1;
}

.trim-start {
  left: 0;
  border-radius: 6px 0 0 6px;
}

.trim-end {
  right: 0;
  border-radius: 0 6px 6px 0;
}

.clip-content {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.clip-watermark {
  position: absolute;
  bottom: 4px;
  left: 4px;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: bold;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.clip-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.clip-title {
  font-size: 11px;
  font-weight: 500;
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px;
  line-height: 1.2;
}

.clip-duration {
  font-size: 9px;
  color: rgba(255, 255, 255, 0.8);
  font-family: 'Monaco', 'Menlo', monospace;
  margin-top: 2px;
}

.clip-controls {
  position: absolute;
  top: 4px;
  right: 4px;
  opacity: 0;
  transition: opacity 0.2s;
}

.clip-item:hover .clip-controls {
  opacity: 1;
}

.btn-edit-clip {
  background: rgba(0, 0, 0, 0.5);
  border: none;
  padding: 2px 4px;
  border-radius: 2px;
  cursor: pointer;
  font-size: 10px;
}

.clip-tooltip {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
  margin-bottom: 8px;
}

.clip-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 4px solid transparent;
  border-top-color: rgba(0, 0, 0, 0.9);
}

.tooltip-actions {
  margin-top: 4px;
  font-size: 10px;
  color: #ccc;
}

.clip-edit-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.edit-dialog-content {
  background: #2d2d2d;
  padding: 24px;
  border-radius: 8px;
  width: 400px;
  max-width: 90vw;
}

.edit-dialog-content h4 {
  margin-bottom: 16px;
  color: #fff;
}

.edit-field {
  margin-bottom: 16px;
}

.edit-field label {
  display: block;
  margin-bottom: 4px;
  color: #ccc;
  font-size: 14px;
}

.edit-field input,
.edit-field textarea {
  width: 100%;
  background: #333;
  border: 1px solid #555;
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;
}

.edit-field input:focus,
.edit-field textarea:focus {
  outline: none;
  border-color: #007AFF;
}

.edit-time-info {
  background: #1a1a1a;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 12px;
  color: #ccc;
  font-family: 'Monaco', 'Menlo', monospace;
}

.edit-time-info div {
  margin-bottom: 4px;
}

.edit-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.btn-save {
  background: #4CAF50;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

/* 导出对话框样式 */
.export-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
}

.export-dialog {
  background: #2d2d2d;
  border-radius: 8px;
  width: 600px;
  max-width: 90vw;
  max-height: 90vh;
  overflow-y: auto;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #404040;
}

.dialog-header h3 {
  color: #fff;
  font-size: 18px;
}

.btn-close {
  background: none;
  border: none;
  color: #888;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-close:hover {
  color: #fff;
}

.dialog-content {
  padding: 24px;
}

.export-info {
  margin-bottom: 24px;
}

.export-info h4 {
  color: #fff;
  margin-bottom: 12px;
  font-size: 16px;
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  font-size: 14px;
  color: #ccc;
}

.export-settings {
  margin-bottom: 24px;
}

.export-settings h4 {
  color: #fff;
  margin-bottom: 16px;
  font-size: 16px;
}

.setting-group {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.setting-group label {
  min-width: 80px;
  color: #ccc;
  font-size: 14px;
}

.setting-group select {
  background: #333;
  border: 1px solid #555;
  color: white;
  padding: 6px 8px;
  border-radius: 4px;
  cursor: pointer;
  min-width: 150px;
}

.setting-group input[type="checkbox"] {
  margin-right: 8px;
}

.export-progress {
  margin-bottom: 24px;
}

.export-progress h4 {
  color: #fff;
  margin-bottom: 12px;
  font-size: 16px;
}

.progress-bar {
  height: 8px;
  background: #444;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;
}

.progress-fill {
  height: 100%;
  background: #4CAF50;
  transition: width 0.3s;
}

.progress-text {
  text-align: center;
  color: #ccc;
  font-size: 14px;
}

.export-preview {
  margin-bottom: 24px;
}

.export-preview h4 {
  color: #fff;
  margin-bottom: 12px;
  font-size: 16px;
}

.clips-preview {
  max-height: 200px;
  overflow-y: auto;
  background: #1a1a1a;
  border-radius: 4px;
  padding: 8px;
}

.preview-clip {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 8px;
  border-radius: 4px;
  margin-bottom: 4px;
  font-size: 14px;
}

.preview-clip:hover {
  background: #333;
}

.clip-index {
  color: #888;
  font-family: 'Monaco', 'Menlo', monospace;
  min-width: 20px;
}

.clip-title {
  flex: 1 1;
  color: #fff;
}

.clip-duration {
  color: #ccc;
  font-family: 'Monaco', 'Menlo', monospace;
}

.dialog-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding: 20px 24px;
  border-top: 1px solid #404040;
}

.btn-export {
  background: #4CAF50;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}

.btn-export:hover {
  background: #45a049;
}

.btn-export:disabled {
  background: #666;
  cursor: not-allowed;
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #1a1a1a;
}

::-webkit-scrollbar-thumb {
  background: #555;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #666;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .video-container {
    height: 250px;
  }
  
  .info-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .video-controls {
    flex-wrap: wrap;
    gap: 8px;
  }
  
  .recording-buttons {
    margin-left: 0;
    width: 100%;
    justify-content: center;
  }
  
  .track-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .track-controls {
    align-self: flex-end;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA,WAAW;AACX;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gFAAgF;EAChF,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,YAAY,EAAE;EACpB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yCAAyC;AAC3C;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA,WAAW;AACX;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,YAAY;AACZ;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,mCAAmC;EACnC,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,QAAQ;EACR,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA,YAAY;AACZ;EACE,+CAA+C;EAC/C,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,iBAAiB;EACjB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,0BAA0B;AAC5B;;AAEA;EACE,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":["/* 全局样式重置 */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  background-color: #1a1a1a;\n  color: #ffffff;\n  overflow: hidden;\n}\n\n/* 应用主容器 */\n.app {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.app-header {\n  background: #2d2d2d;\n  padding: 10px 20px;\n  border-bottom: 1px solid #404040;\n  -webkit-app-region: drag;\n}\n\n.app-header h1 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #ffffff;\n  -webkit-app-region: no-drag;\n}\n\n.app-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* 按钮样式 */\n.btn-primary {\n  background: #007AFF;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s;\n}\n\n.btn-primary:hover {\n  background: #0056CC;\n}\n\n.btn-primary:disabled {\n  background: #666;\n  cursor: not-allowed;\n}\n\n.btn-control {\n  background: #333;\n  color: white;\n  border: 1px solid #555;\n  padding: 8px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n  min-width: 40px;\n}\n\n.btn-control:hover {\n  background: #444;\n}\n\n.btn-control:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* 视频播放器样式 */\n.video-player {\n  background: #000;\n  border-bottom: 1px solid #333;\n}\n\n.video-controls {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 20px;\n  background: #2d2d2d;\n  border-bottom: 1px solid #404040;\n}\n\n.speed-select {\n  background: #333;\n  color: white;\n  border: 1px solid #555;\n  padding: 6px 8px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.recording-buttons {\n  display: flex;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.btn-offense {\n  background: #4CAF50;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.btn-offense:hover {\n  background: #45a049;\n}\n\n.btn-offense.recording {\n  background: #FF5722;\n  animation: pulse 1s infinite;\n}\n\n.btn-defense {\n  background: #F44336;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.btn-defense:hover {\n  background: #d32f2f;\n}\n\n.btn-defense.recording {\n  background: #FF5722;\n  animation: pulse 1s infinite;\n}\n\n@keyframes pulse {\n  0% { opacity: 1; }\n  50% { opacity: 0.7; }\n  100% { opacity: 1; }\n}\n\n.video-container {\n  position: relative;\n  height: 300px;\n  background: #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.video-element {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.video-placeholder {\n  text-align: center;\n  color: #888;\n}\n\n.video-placeholder p {\n  margin-bottom: 16px;\n  font-size: 16px;\n}\n\n.progress-container {\n  padding: 12px 20px;\n  background: #2d2d2d;\n}\n\n.progress-bar {\n  position: relative;\n  height: 6px;\n  background: #444;\n  border-radius: 3px;\n  cursor: pointer;\n  margin-bottom: 8px;\n}\n\n.progress-fill {\n  height: 100%;\n  background: #007AFF;\n  border-radius: 3px;\n  transition: width 0.1s;\n}\n\n.recording-marker {\n  position: absolute;\n  top: -2px;\n  width: 3px;\n  height: 10px;\n  border-radius: 1px;\n}\n\n.offense-marker {\n  background: #4CAF50;\n}\n\n.defense-marker {\n  background: #F44336;\n}\n\n.time-display {\n  text-align: center;\n  font-size: 14px;\n  color: #ccc;\n  font-family: 'Monaco', 'Menlo', monospace;\n}\n\n/* 时间轴样式 */\n.timeline-container {\n  background: #2d2d2d;\n  border-bottom: 1px solid #404040;\n  padding: 16px 20px;\n}\n\n.timeline-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.timeline-header h3 {\n  font-size: 16px;\n  color: #fff;\n}\n\n.timeline-info {\n  display: flex;\n  gap: 20px;\n  font-size: 12px;\n  color: #888;\n  font-family: 'Monaco', 'Menlo', monospace;\n}\n\n.timeline-track {\n  position: relative;\n  height: 40px;\n  background: #1a1a1a;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-bottom: 8px;\n}\n\n.time-markers {\n  position: absolute;\n  top: -20px;\n  left: 0;\n  right: 0;\n  height: 20px;\n}\n\n.time-marker {\n  position: absolute;\n  font-size: 10px;\n  color: #666;\n}\n\n.marker-line {\n  width: 1px;\n  height: 8px;\n  background: #666;\n  margin-bottom: 2px;\n}\n\n.marker-text {\n  font-family: 'Monaco', 'Menlo', monospace;\n  white-space: nowrap;\n  transform: translateX(-50%);\n}\n\n.timeline-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #333;\n  border-radius: 4px;\n}\n\n.timeline-progress {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  background: rgba(0, 122, 255, 0.3);\n  border-radius: 4px;\n}\n\n.timeline-playhead {\n  position: absolute;\n  top: -5px;\n  bottom: -5px;\n  width: 2px;\n  transform: translateX(-1px);\n}\n\n.playhead-line {\n  width: 2px;\n  height: 100%;\n  background: #007AFF;\n}\n\n.playhead-handle {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 12px;\n  height: 12px;\n  background: #007AFF;\n  border: 2px solid #fff;\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n  cursor: grab;\n}\n\n.playhead-handle:active {\n  cursor: grabbing;\n}\n\n.timeline-time-display {\n  text-align: center;\n  font-size: 14px;\n  color: #ccc;\n  font-family: 'Monaco', 'Menlo', monospace;\n}\n\n.timeline-placeholder {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n/* 轨道列表样式 */\n.track-list {\n  flex: 1;\n  background: #1a1a1a;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.track-list-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.track-list-header h3 {\n  font-size: 18px;\n  color: #fff;\n}\n\n.btn-add-track {\n  background: #007AFF;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.btn-add-track:hover {\n  background: #0056CC;\n}\n\n.new-track-input {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 16px;\n  padding: 12px;\n  background: #2d2d2d;\n  border-radius: 6px;\n}\n\n.new-track-input input {\n  flex: 1;\n  background: #333;\n  border: 1px solid #555;\n  color: white;\n  padding: 8px 12px;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.new-track-input input:focus {\n  outline: none;\n  border-color: #007AFF;\n}\n\n.btn-confirm {\n  background: #4CAF50;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.btn-cancel {\n  background: #666;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.tracks-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.track-item {\n  background: #2d2d2d;\n  border-radius: 8px;\n  padding: 16px;\n  border: 1px solid #404040;\n  transition: all 0.2s ease;\n  cursor: default;\n  position: relative;\n}\n\n.track-item:hover {\n  border-color: #555;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n/* 拖拽状态样式 - 由framer-motion的whileDrag控制 */\n.track-item[data-rbd-dragging-over] {\n  background: #3a3a3a;\n  border-color: #007AFF;\n  box-shadow: 0 4px 16px rgba(0, 122, 255, 0.2);\n}\n\n/* 拖拽占位符样式 */\n.track-item[data-rbd-drag-handle-dragging-color] {\n  background: #3a3a3a !important;\n  border-color: #007AFF !important;\n  transform: rotate(1deg) scale(1.02);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n}\n\n.track-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  cursor: grab;\n  user-select: none;\n}\n\n.track-header:active {\n  cursor: grabbing;\n}\n\n.track-drag-handle {\n  display: flex;\n  align-items: center;\n  padding: 4px;\n  margin-right: 8px;\n  cursor: grab;\n}\n\n.track-drag-handle:active {\n  cursor: grabbing;\n}\n\n.drag-dots {\n  display: grid;\n  grid-template-columns: repeat(2, 4px);\n  grid-template-rows: repeat(3, 4px);\n  gap: 2px;\n  opacity: 0.6;\n  transition: opacity 0.2s;\n}\n\n.track-header:hover .drag-dots {\n  opacity: 1;\n}\n\n.drag-dots span {\n  width: 4px;\n  height: 4px;\n  background: #888;\n  border-radius: 50%;\n  transition: background-color 0.2s;\n}\n\n.track-header:hover .drag-dots span {\n  background: #ccc;\n}\n\n.track-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.track-color-indicator {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n}\n\n.track-name {\n  font-size: 16px;\n  color: #fff;\n  cursor: pointer;\n}\n\n.track-name:hover {\n  color: #007AFF;\n}\n\n.track-stats {\n  display: flex;\n  gap: 16px;\n  font-size: 12px;\n  color: #888;\n}\n\n.track-controls {\n  display: flex;\n  gap: 8px;\n}\n\n.btn-play-track {\n  background: #4CAF50;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.btn-play-track:disabled {\n  background: #666;\n  cursor: not-allowed;\n}\n\n.btn-export-track {\n  background: #FF9800;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.btn-export-track:disabled {\n  background: #666;\n  cursor: not-allowed;\n}\n\n.btn-delete-track {\n  background: #F44336;\n  color: white;\n  border: none;\n  padding: 6px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n}\n\n.clips-container {\n  min-height: 60px;\n}\n\n.empty-track-message {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 60px;\n  border: 2px dashed #555;\n  border-radius: 4px;\n  color: #888;\n  font-size: 14px;\n  text-align: center;\n  padding: 10px;\n}\n\n.empty-track {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 60px;\n  border: 2px dashed #555;\n  border-radius: 4px;\n  color: #888;\n  font-size: 14px;\n}\n\n.clips-grid {\n  display: flex;\n  gap: 8px;\n  flex-wrap: nowrap;\n  align-items: center;\n  min-height: 50px;\n  padding: 4px;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  justify-content: flex-start;\n}\n\n.clips-grid > * {\n  flex-shrink: 0;\n  margin: 0;\n}\n\n.clips-grid::-webkit-scrollbar {\n  height: 4px;\n}\n\n.clips-grid::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.clips-grid::-webkit-scrollbar-thumb {\n  background: #555;\n  border-radius: 2px;\n}\n\n.clips-grid::-webkit-scrollbar-thumb:hover {\n  background: #666;\n}\n\n.clips-list {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.track-summary {\n  margin-top: 20px;\n  padding: 16px;\n  background: #2d2d2d;\n  border-radius: 6px;\n  display: flex;\n  gap: 20px;\n}\n\n.summary-item {\n  font-size: 14px;\n  color: #ccc;\n}\n\n/* 片段样式 */\n.clip-item {\n  position: relative;\n  background: #4CAF50;\n  border-radius: 6px;\n  padding: 6px 10px;\n  cursor: grab;\n  user-select: none;\n  border: 2px solid transparent;\n  transition: all 0.2s ease;\n  min-width: 80px;\n  max-width: 150px;\n  width: auto;\n  display: inline-block;\n  flex-shrink: 0;\n  vertical-align: top;\n  box-sizing: border-box;\n}\n\n.clip-item:hover {\n  border-color: rgba(255, 255, 255, 0.3);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.clip-item:active {\n  cursor: grabbing;\n}\n\n/* 拖拽时的插入指示器 */\n.clips-grid::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 2px;\n  background: #007AFF;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n  pointer-events: none;\n}\n\n.clips-grid[data-dragging=\"true\"]::before {\n  opacity: 1;\n}\n\n/* 拖拽占位符样式 */\n.clip-item[data-rbd-dragging-over] {\n  background: rgba(255, 255, 255, 0.1) !important;\n  border: 2px dashed #007AFF !important;\n}\n\n.clip-item[data-rbd-drag-handle-dragging-color] {\n  opacity: 0.8;\n  transform: rotate(2deg) scale(1.05);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4);\n}\n\n.clip-item.offense {\n  background: #4CAF50;\n}\n\n.clip-item.defense {\n  background: #F44336;\n}\n\n.trim-handle {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 8px;\n  background: rgba(255, 255, 255, 0.3);\n  cursor: ew-resize;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.clip-item:hover .trim-handle {\n  opacity: 1;\n}\n\n.trim-start {\n  left: 0;\n  border-radius: 6px 0 0 6px;\n}\n\n.trim-end {\n  right: 0;\n  border-radius: 0 6px 6px 0;\n}\n\n.clip-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.clip-watermark {\n  position: absolute;\n  bottom: 4px;\n  left: 4px;\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.6);\n  font-weight: bold;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n.clip-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.clip-title {\n  font-size: 11px;\n  font-weight: 500;\n  color: white;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100px;\n  line-height: 1.2;\n}\n\n.clip-duration {\n  font-size: 9px;\n  color: rgba(255, 255, 255, 0.8);\n  font-family: 'Monaco', 'Menlo', monospace;\n  margin-top: 2px;\n}\n\n.clip-controls {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.clip-item:hover .clip-controls {\n  opacity: 1;\n}\n\n.btn-edit-clip {\n  background: rgba(0, 0, 0, 0.5);\n  border: none;\n  padding: 2px 4px;\n  border-radius: 2px;\n  cursor: pointer;\n  font-size: 10px;\n}\n\n.clip-tooltip {\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.9);\n  color: white;\n  padding: 8px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  white-space: nowrap;\n  z-index: 1000;\n  margin-bottom: 8px;\n}\n\n.clip-tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 4px solid transparent;\n  border-top-color: rgba(0, 0, 0, 0.9);\n}\n\n.tooltip-actions {\n  margin-top: 4px;\n  font-size: 10px;\n  color: #ccc;\n}\n\n.clip-edit-dialog {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n}\n\n.edit-dialog-content {\n  background: #2d2d2d;\n  padding: 24px;\n  border-radius: 8px;\n  width: 400px;\n  max-width: 90vw;\n}\n\n.edit-dialog-content h4 {\n  margin-bottom: 16px;\n  color: #fff;\n}\n\n.edit-field {\n  margin-bottom: 16px;\n}\n\n.edit-field label {\n  display: block;\n  margin-bottom: 4px;\n  color: #ccc;\n  font-size: 14px;\n}\n\n.edit-field input,\n.edit-field textarea {\n  width: 100%;\n  background: #333;\n  border: 1px solid #555;\n  color: white;\n  padding: 8px 12px;\n  border-radius: 4px;\n  font-size: 14px;\n  resize: vertical;\n}\n\n.edit-field input:focus,\n.edit-field textarea:focus {\n  outline: none;\n  border-color: #007AFF;\n}\n\n.edit-time-info {\n  background: #1a1a1a;\n  padding: 12px;\n  border-radius: 4px;\n  margin-bottom: 16px;\n  font-size: 12px;\n  color: #ccc;\n  font-family: 'Monaco', 'Menlo', monospace;\n}\n\n.edit-time-info div {\n  margin-bottom: 4px;\n}\n\n.edit-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.btn-save {\n  background: #4CAF50;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n/* 导出对话框样式 */\n.export-dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3000;\n}\n\n.export-dialog {\n  background: #2d2d2d;\n  border-radius: 8px;\n  width: 600px;\n  max-width: 90vw;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.dialog-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #404040;\n}\n\n.dialog-header h3 {\n  color: #fff;\n  font-size: 18px;\n}\n\n.btn-close {\n  background: none;\n  border: none;\n  color: #888;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.btn-close:hover {\n  color: #fff;\n}\n\n.dialog-content {\n  padding: 24px;\n}\n\n.export-info {\n  margin-bottom: 24px;\n}\n\n.export-info h4 {\n  color: #fff;\n  margin-bottom: 12px;\n  font-size: 16px;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  font-size: 14px;\n  color: #ccc;\n}\n\n.export-settings {\n  margin-bottom: 24px;\n}\n\n.export-settings h4 {\n  color: #fff;\n  margin-bottom: 16px;\n  font-size: 16px;\n}\n\n.setting-group {\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.setting-group label {\n  min-width: 80px;\n  color: #ccc;\n  font-size: 14px;\n}\n\n.setting-group select {\n  background: #333;\n  border: 1px solid #555;\n  color: white;\n  padding: 6px 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  min-width: 150px;\n}\n\n.setting-group input[type=\"checkbox\"] {\n  margin-right: 8px;\n}\n\n.export-progress {\n  margin-bottom: 24px;\n}\n\n.export-progress h4 {\n  color: #fff;\n  margin-bottom: 12px;\n  font-size: 16px;\n}\n\n.progress-bar {\n  height: 8px;\n  background: #444;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n\n.progress-fill {\n  height: 100%;\n  background: #4CAF50;\n  transition: width 0.3s;\n}\n\n.progress-text {\n  text-align: center;\n  color: #ccc;\n  font-size: 14px;\n}\n\n.export-preview {\n  margin-bottom: 24px;\n}\n\n.export-preview h4 {\n  color: #fff;\n  margin-bottom: 12px;\n  font-size: 16px;\n}\n\n.clips-preview {\n  max-height: 200px;\n  overflow-y: auto;\n  background: #1a1a1a;\n  border-radius: 4px;\n  padding: 8px;\n}\n\n.preview-clip {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 6px 8px;\n  border-radius: 4px;\n  margin-bottom: 4px;\n  font-size: 14px;\n}\n\n.preview-clip:hover {\n  background: #333;\n}\n\n.clip-index {\n  color: #888;\n  font-family: 'Monaco', 'Menlo', monospace;\n  min-width: 20px;\n}\n\n.clip-title {\n  flex: 1;\n  color: #fff;\n}\n\n.clip-duration {\n  color: #ccc;\n  font-family: 'Monaco', 'Menlo', monospace;\n}\n\n.dialog-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  padding: 20px 24px;\n  border-top: 1px solid #404040;\n}\n\n.btn-export {\n  background: #4CAF50;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.btn-export:hover {\n  background: #45a049;\n}\n\n.btn-export:disabled {\n  background: #666;\n  cursor: not-allowed;\n}\n\n/* 滚动条样式 */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #1a1a1a;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #555;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #666;\n}\n\n/* 响应式设计 */\n@media (max-width: 1200px) {\n  .video-container {\n    height: 250px;\n  }\n  \n  .info-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .video-controls {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n  \n  .recording-buttons {\n    margin-left: 0;\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .track-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .track-controls {\n    align-self: flex-end;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
